import { MinesTemplate } from '@/components/templates/Mines/templates/Mines'
import { useAppModal, AppModals } from '@/context/ModalProvider'
import { useMaintenance } from '@/hooks/useMaintenance'
import { useEffect } from 'react'

const MinesPage = () => {
  const { isMaintenance } = useMaintenance()
  const modal = useAppModal()

  useEffect(() => {
    if (isMaintenance) {
      modal.openModalNew(AppModals.MaintenanceModal)
    }
  }, [])

  return <MinesTemplate />
}

export default MinesPage
